import React from "react";
import ReactMarkdown from "react-markdown";
import { registerView, ViewComponent } from "@frui.ts/views";
import OrderOutageViewModel from "../../../viewModels/common/orderOutage/orderOutageViewModel";
import { observer } from "mobx-react-lite";

const OrderOutageView: ViewComponent<OrderOutageViewModel> = observer(({ vm }) => {
  return (
    <div className="content text-center py-11 pb-5">
      <h1 className="text-center mb-5">{vm.translate("title")}</h1>
      <div className="row mb-5 justify-content-center">
        <div className="col-12 col-lg-8 font-weight-bold">
          <ReactMarkdown>{vm.message}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
});

registerView(OrderOutageView, OrderOutageViewModel);
